<template>
    <button
        class="o-w-item-search-tile  w-item-search-tile w-item-tile--odd-background"
        type="button"
        role="button"
        :aria-label="`${ariaLabel}${t(item, 'name')}`"
        @click.stop="onTileClick"
    >
        <div class="w-item-search-tile__logo-wrapper">
            <img
                v-if="t(item, 'icon')"
                :src="t(item, 'icon')"
                alt="logo image"
                class="w-item-search-tile__logo"
            />
            <svg-icon
                v-else
                original
                :name="`icons/shop-logo`"
                class="w-item-search-tile__logo"
            />
        </div>

        <div class="w-item-search-tile__wrapper">
            <span class=" w-item-search-tile__title">
                {{ t(item, 'name') }}
            </span>
            <span
                class=" w-item-search-tile__subtitle"
            >
                {{ t(item, 'floor') }}
            </span>
        </div>

        <img
            v-if="!isGuide"
            @click.stop="onClick"
            class="w-item-search-tile__guide-button"
            src="../../../assets/images/icons/directions.png"
            :alt="`Show guide to ${t(item,'name')}`"
            :title="`Show guide to ${t(item,'name')}`"
        />
        <svg-icon
            v-else
            original
            name="icons/path-dark"
            class="w-item-search-tile__icon"
        />
    </button>
</template>

<script>
import { mapGetters } from 'vuex';
import { Storage } from '../../../utils/services/storage-service';
import { MENU_REDIRECT_URL } from "../../../utils/constants/app-constants";

export default {
    name: 'OWItemSearchTile',
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        ariaLabel: {
            type: String,
            default: 'Title - '
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getCategoryById',
            'getDenormalisedObjectById'
        ]),
        denormalisedObject() {
            return this.getDenormalisedObjectById(this.item.id);
        },
        isGuide(){
            return this.$route.name.includes('guide');
        },
    },
    methods: {
        onClick() {
            this.$emit('onClick', this.item);
        },
        onTileClick(){
            if(this.isGuide){
                this.$emit('onClick', this.item);
                return;
            }

            const q = this.$route.query;
            const t = this.item.id;
            const platform = this.$route.name.includes('mobile') ? 'mobile': 'web';

            Storage.local.set(MENU_REDIRECT_URL, {
                name: this.$route.name,
                params: this.$route.params,
                query: this.$route.query
            });

            this.$router.push({
                name:`${platform}.explore`,
                query:{
                    ...q,
                    t,
                },
                params:{
                    canGoBack: true,
                }
            });

        },
    }
}
</script>

<style lang="scss" src="./o-w-item-search-tile.scss" />
